export default __webpack_public_path__ + "static/media/ic_sharp-logout.1ee6318f.svg";